function StarLgIcon() {
  return (
    <svg
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.22375 0.762731L9.41074 3.16784L12.0649 3.55352C13.1847 3.71623 13.6318 5.09234 12.8216 5.88217L10.901 7.75428L11.3544 10.3978C11.5456 11.513 10.3751 12.3635 9.37349 11.8369L6.9995 10.5889L4.62552 11.8369C3.62395 12.3635 2.45337 11.513 2.64465 10.3978L3.09804 7.75428L1.17744 5.88217C0.367162 5.09234 0.814287 3.71623 1.93407 3.55352L4.58827 3.16784L5.77526 0.762731C6.27604 -0.251965 7.72296 -0.251965 8.22375 0.762731Z"
        fill="#FFF4DE"
      />
    </svg>
  );
}

export default StarLgIcon;
